import type { RouteObject } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import Home from "@/pages/Home";
import USGACalculator from "@/pages/USGACalculator";
import ScrambleTools from "@/pages/ScrambleTools";
import Formulas from "@/pages/Formulas";
import NineHoleCalculator from "@/pages/NineHoleCalculator";

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/usga-calculator", element: <USGACalculator /> },
  { path: "/scramble-tools", element: <ScrambleTools /> },
  { path: "/formulas", element: <Formulas /> },
  { path: "/9-hole-calculator", element: <NineHoleCalculator /> },
];

function App() {
  return useRoutes(routes);
}

export default App;
